export const LOAD_PROJECTS_FOLDERS_TREE = 'LOAD_PROJECTS_FOLDERS_TREE'
export const GET_PROJECTS_FOLDER_BY_ID = 'GET_PROJECTS_FOLDER_BY_ID'
export const MOVE_ROOM_INTO_FOLDER = 'MOVE_ROOM_INTO_FOLDER'
